import {CanvasDrawable} from '@catdetails/components/project-lopa-positions/drawable/canvas-drawable';

export class CanvasState {
  static NO_IMAGE_PLACEHOLDER = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAAXNSR0IB2cksfwAAAYBQTFRFAAAAMjIyLi4uMDAwKysrMjIyMzMzMzMzMjIyLCwsMzMzMjIyMjIyMzMzMzMzMjIyMjIyMzMzMjIyMjIyMjIyMjIyMzMzMDAwMzMzMjIyMjIyKysrMzMzMzMzMjIyMTExMzMzMjIyMTExMTExMzMzMjIyAAAAMjIyMzMzMzMzMjIyMjIyMjIyMjIyMTExMjIyMjIyMjIyMjIyLi4uMzMzMzMzMjIyMTExMjIyMjIyMTExMjIyICAgAAAAMjIyMzMzMzMzMzMzMzMzMjIyMjIyMzMzMjIyMjIyMjIyMzMzMzMzMjIyMjIyKysrLy8vMjIyEhISMjIyLi4uMTExMTExAAAAMTExMjIyMjIyMzMzMzMzMTExMzMzMzMzAAAAMzMzAAAAMTExMjIyMzMzMjIyMjIyMzMzMjIyMjIyMzMzKysrMzMzHBwcMzMzMDAwMjIyLS0tMzMzMjIyMzMzMzMzMjIyMjIyMzMzMDAwJCQkMzMzKCgoMzMzMzMzMzMzMzMzfS3bfAAAAIB0Uk5TAOQsIAb0oegzHdnfR7SlwZqWu4XbwgVPybajKtTdTGN5j1NJVakG6QrYOLwpi1h6ilGxHLBkgETLSFSoCANl7b4yklfMpp2ucc1a1rISMVIO/hZ3QwR82sCIlx/cSwLiARqf0lasq7eEPAzsCYM6yhHxrarmmaKcQAfPE2qHgl9cuU/3AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABDUlEQVR4nGNgGAUjFTAyEamQmQWfLCsbOwcnFzcP2ERePn4BQSEGYRFRMXEJSSlpGVk5hEJmXnkFRSVeiEJlFVUGVjV1DU0tbR1dPX0DQyOEQmMTU0UzcwuIQksrawZWG1s7e3MHRydnJxdXN7wK3T08zb28fTSczHz9UBQqKPrzIikMCAwSMTcJDgkNgzgJoZBTE+YZiImS4RHikULhUdHhMbGEgiouPiFRm2CAgkCSbLIcITUpjkQZxcCQakpAQRqXvG16eAYHu0wmXnVZ2Tm5efkFhYRNLCoW8y8ptQglqFCsrNw/Iq4igZDCaL7KksyqalYG6xr8CuOMNGtDHWLqGOrZKwjYPQoGCQAAkdMy9JQxe0IAAAAASUVORK5CYII=';
  private static hitMapColorCounter = 0;
  private static hitColorMap = new Map<string, CanvasDrawable<any>>();
  private width: number;
  private height: number;
  private context: CanvasRenderingContext2D;
  private hitMapCanvas: HTMLCanvasElement;
  private hitMapContext: CanvasRenderingContext2D;
  // Style offsets
  private stylePaddingLeft: number;
  private stylePaddingTop: number;
  private styleBorderLeft: number;
  private styleBorderTop: number;
  private htmlTop: number;
  private htmlLeft: number;
  //
  private valid: boolean;
  private drawablesByLayer: Map<number, Array<CanvasDrawable<any>>>;
  private dragging: boolean;
  selection: CanvasDrawable<any>;
  private selectionMousePos: { x: number; y: number };
  selectionColor = '#CC0000';
  private selectionWidth = 2;
  private drawInterval = 30;
  shadowBlur = 2;
  shadowColor = '#4D4D4D';
  public static getNextHitMapColor(drawable: CanvasDrawable<any>) {
    this.hitMapColorCounter++;
    const hexString = '#' + ('000000' + this.hitMapColorCounter.toString(16)).substr(-6);
    this.hitColorMap.set(hexString, drawable);
    return hexString;
  }
  constructor(private canvas: HTMLCanvasElement, private backgroundImage?: HTMLImageElement) {
    if (backgroundImage) {
      canvas.width = backgroundImage.width;
      canvas.height = backgroundImage.height;
    }
    this.width = canvas.width;
    this.height = canvas.height;
    this.context = canvas.getContext('2d');
    // Build hit map canvas
    this.hitMapCanvas = document.createElement('canvas');
    // document.appendChild(this.hitMapCanvas);
    this.hitMapCanvas.width = this.width;
    this.hitMapCanvas.height = this.height;
    this.hitMapContext = this.hitMapCanvas.getContext('2d');
    // Collect style offsets
    if (document.defaultView && document.defaultView.getComputedStyle) {
      const computedStyle = document.defaultView.getComputedStyle(canvas, null);
      this.stylePaddingLeft = parseInt(computedStyle['paddingLeft'], 10)      || 0;
      this.stylePaddingTop  = parseInt(computedStyle['paddingTop'], 10)       || 0;
      this.styleBorderLeft  = parseInt(computedStyle['borderLeftWidth'], 10)  || 0;
      this.styleBorderTop   = parseInt(computedStyle['borderTopWidth'], 10)   || 0;
    }
    const html = document.body.parentElement;
    this.htmlTop = html.offsetTop;
    this.htmlLeft = html.offsetLeft;
    // State vars
    this.valid = false; // redraw if false
    this.drawablesByLayer = new Map();  // Drawables to be drawn
    this.dragging = false; // User is dragging
    // Selected element
    this.selection = null;
    // Handle mouse events
    const self = this;
    // Disable text selection on double click
    canvas.addEventListener('selectstart', (e) => { e.preventDefault(); return false; }, false);
    // Drag and drop
    canvas.addEventListener('mousedown', (e) => {
      const mouse = self.getMouse(e);
      if (!mouse) { return; }
      this.selectionMousePos = mouse;
      if (this.hitMapCanvas) {
        const pixelData = this.hitMapContext.getImageData(mouse.x, mouse.y, 1, 1).data;
        const hex = '#' + ('000000' + this.rgbToHex(pixelData[0], pixelData[1], pixelData[2])).slice(-6);
        if (CanvasState.hitColorMap.has(hex)) {
          const sel = CanvasState.hitColorMap.get(hex);
          self.dragging = true;
          self.selection = sel;
          self.valid = false;
          return;
        }
      }
      // Nothing selected - clear old selection
      if (self.selection) {
        self.selection = null;
        self.valid = false;
      }
    }, true);
    canvas.addEventListener('mousemove', (e) => {
      if (self.dragging) {
        const mouse = self.getMouse(e);
        if (!mouse) { return; }
        self.selection.move(mouse.x - this.selectionMousePos.x, mouse.y - this.selectionMousePos.y);
        this.selectionMousePos = mouse;
        self.valid = false;
      }
    }, true);
    canvas.addEventListener('mouseup', (e) => {
      self.dragging = false;
      self.selectionMousePos = null;
    }, true);

    canvas.addEventListener('keydown', (e) => {
      if (this.selection) {
        e.preventDefault();
        const delta = e.shiftKey ? e.ctrlKey ? 100 : 10 : e.ctrlKey ? 50 : 1;
        let dx = 0;
        let dy = 0;
        switch (e.key) {
          case 'ArrowLeft': dx = -delta; break;
          case 'ArrowRight': dx = delta; break;
          case 'ArrowUp': dy = -delta; break;
          case 'ArrowDown': dy = delta; break;
        }
        this.selection.move(dx, dy);
        this.invalidate();
      }
    }, false);
    setInterval(() => { self.draw(); }, self.drawInterval);
  }

  rgbToHex(r, g, b) {
    if (r > 255 || g > 255 || b > 255) {
      return '';
    }
    return ((r << 16) | (g << 8) | b).toString(16);
  }

  clear() {
    this.context.clearRect(0, 0, this.width, this.height);
    this.hitMapContext.clearRect(0, 0, this.width, this.height);
  }
  addDrawable(d: CanvasDrawable<any>, layer: number = 0) {
    if (layer < 0) {
      console.error('Layers start at 0!');
    }

    if (!this.drawablesByLayer.has(layer)) {
      this.drawablesByLayer.set(layer, [d]);
    } else {
      this.drawablesByLayer.get(layer).push(d);
    }
    this.valid = false;
  }
  draw() {
    if (!this.valid) {
      this.clear();

      // Draw background
      if (this.backgroundImage) {
        this.context.drawImage(this.backgroundImage, 0, 0);
      }

      // set shadow
      this.context.shadowColor = this.shadowColor;
      this.context.shadowBlur = this.shadowBlur;
      // draw all shapes
      Array.from(this.drawablesByLayer.keys()).sort().forEach((key) => {
        this.drawablesByLayer.get(key).forEach((d: CanvasDrawable<any>) => {
          if (this.selection === null || d !== this.selection) {
            d.draw(this.context, this.hitMapContext);
          }
        });
      });
      this.context.shadowBlur = 0;
      // Draw selection
      if (this.selection !== null) {
        this.context.shadowBlur = this.shadowBlur;
        this.selection.draw(this.context, this.hitMapContext);
        this.context.shadowBlur = 0;
        this.selection.select(this.context, this.selectionColor, this.selectionWidth);
      }

      this.valid = true;
    }
  }

  getMouse(e) {
    // let element: HTMLElement = this.canvas;
    let offsetX = 0;
    let offsetY = 0;
    offsetX += this.stylePaddingLeft + this.styleBorderLeft + this.htmlLeft;
    offsetY += this.stylePaddingTop + this.styleBorderTop + this.htmlTop;

    const rect = this.canvas.getBoundingClientRect();
    const screenX = e.offsetX + 1 - offsetX;
    const screenY = e.offsetY + 1 - offsetY;
    // Check bounds
    if (screenX < 0 || screenX >= rect.width || screenY < 0 || screenY >= rect.height) {
      return null;
    }
    return {
      x: Math.round(screenX * this.canvas.width / rect.width),
      y: Math.round(screenY * this.canvas.height / rect.height),
    };
  }
  invalidate() {
    this.valid = false;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/project-lopa-positions/canvas-state.ts